import type { TournamentRoundsApi } from '@/v2/api/metadata/tournament-rounds'
import type { TournamentsApi } from '@/v2/api/metadata/tournaments'
import type { BackofficeContext } from '@/v2/framework/context/types'
import type { DialogConfig } from '@/v2/framework/dialog/types'
import { readApiData } from '@/v2/api/response'
import { createFeedConfigTab } from './tabs/feed-config'
import { createFeedMappingTab } from './tabs/feed-mapping'
import { createConfigurationTab } from './tabs/configuration'
import { limitsTab } from './tabs/limits'
import { createLiveTab } from './tabs/live'
import { createMainTab } from './tabs/main'
import { createPrematchTab } from './tabs/prematch'
import { createRoundsTab } from '../rounds/tab'
import { createTranslationsTab } from './tabs/translations'

export function createEditDialog(options: {
  ctx: BackofficeContext
  tournamentsApi: TournamentsApi
  roundsApi: TournamentRoundsApi
}): DialogConfig {
  const { ctx, tournamentsApi, roundsApi } = options

  return {
    id: 'edit-tournament',
    title: 'Edit tournament',
    layout: {
      type: 'popover',
    },
    api: {
      initialValues: async (row) => {
        const response = await tournamentsApi.getSingle(row.id)
        const data = readApiData(response)
        return (data && typeof data === 'object' && !Array.isArray(data) ? data : {}) as Record<
          string,
          unknown
        >
      },
      submit: async () => {},
    },
    structure: {
      type: 'tabbed',
      savePerTab: true,
      tabs: [
        createMainTab(tournamentsApi),
        createPrematchTab(tournamentsApi),
        createLiveTab(tournamentsApi),
        createTranslationsTab({ ctx, tournamentsApi }),
        createRoundsTab({ ctx, roundsApi }),
        createFeedMappingTab(tournamentsApi),
        limitsTab,
        createConfigurationTab({ tournamentsApi }),
        createFeedConfigTab(tournamentsApi),
      ],
    },
  }
}
